/**
 * Asynchronously loads the component for legacy Collection Editor Panel
 */

import loadable from 'utils/Loadable'

export default loadable(() => import(/* webpackChunkName: "CollectionEditorPanel" */ './index'))
